import styled from "@emotion/styled"
import colors from "theme/colors"
import { Container, Desktop, NewText } from "ui"
import { extractProperty } from "utils"

const TitleBox = styled.div`
  margin-bottom: 32px;
`
function TitleContent({ data }: { data: any }) {
  const title = extractProperty(data, "title")
  return (
    <Container>
      <Desktop>
        <TitleBox>
          <NewText
            component={"h3"}
            desktopFontSize={32}
            desktopLineHeight={"36px"}
            color={colors.black}
          >
            {title}
          </NewText>
        </TitleBox>
      </Desktop>
    </Container>
  )
}

export default TitleContent
